<template>
  <div
    class="card-group"
    :class="{ 'card-group-pc': !isPortrait, 'card-group-mob': isPortrait }"
    :style="groupStyle"
  >
    <div
      v-for="card in cards"
      :key="card.key"
      class="card-item"
      :class="card.className"
    >
      <img
        class="card-image card-image-normal"
        :src="getNormalSrc(card)"
        :alt="card.name"
      >
      <img
        v-if="!isPortrait"
        class="card-image card-image-hover"
        :src="card.hoverSrc"
        :alt="card.name"
      >
      <button
        class="card-hotspot card-hotspot-intro"
        type="button"
        :aria-label="`${card.name}车型介绍`"
        :code-stm="`event, PAGEURL, 点击_车型介绍_${card.name}`"
        @click="scrollToSection(card.sectionId)"
      ></button>
      <button
        class="card-hotspot card-hotspot-link"
        type="button"
        :aria-label="`${card.name}跳转链接`"
        :code-stm="`event, PAGEURL, 点击_跳转链接_${card.name}`"
        @click="openLink(card.link)"
      ></button>
    </div>
  </div>
</template>

<script>
import { isPortraitFun } from "@/utils/utils.js";

const defaultCards = [
  {
    key: "sportage",
    name: "狮铂拓界",
    sectionId: "page1",
    mobSectionId: "mob1",
    link: "/vehicles/new-sportage/",
    normalSrc: "/assets/~/media/images/activity/2026summer/pc/card-sportage.png",
    hoverSrc: "/assets/~/media/images/activity/2026summer/pc/card-sportage-hover.png",
    mobSrc: "/assets/~/media/images/activity/2026summer/mob/card-sportage.png",
    className: "card-item-large",
  },
  {
    key: "kx1",
    name: "奕跑",
    sectionId: "page2",
    mobSectionId: "mob2",
    link: "/vehicles/kx1/",
    normalSrc: "/assets/~/media/images/activity/2026summer/pc/card-kx1.png",
    hoverSrc: "/assets/~/media/images/activity/2026summer/pc/card-kx1-hover.png",
    mobSrc: "/assets/~/media/images/activity/2026summer/mob/card-kx1.png",
    className: "card-item-small card-item-top",
  },
  {
    key: "k3",
    name: "K3",
    sectionId: "page3",
    mobSectionId: "mob3",
    link: "/vehicles/thenewk3/",
    normalSrc: "/assets/~/media/images/activity/2026summer/pc/card-k3.png",
    hoverSrc: "/assets/~/media/images/activity/2026summer/pc/card-k3-hover.png",
    mobSrc: "/assets/~/media/images/activity/2026summer/mob/card-k3.png",
    className: "card-item-small card-item-bottom",
  },
];

export default {
  name: "CardGroup",
  props: {
    cardList: {
      type: Array,
      default: () => [],
    },
    top: {
      type: String,
      default: "calc(986 / 1920 * 100vw)",
    },
    left: {
      type: String,
      default: "50%",
    },
    mobTop: {
      type: String,
      default: "calc(1264 / 750 * 100vw)",
    },
    mobLeft: {
      type: String,
      default: "50%",
    },
    zIndex: {
      type: [String, Number],
      default: 10,
    },
  },
  data() {
    return {
      isPortrait: isPortraitFun(),
    };
  },
  mounted() {
    window.addEventListener("resize", this.updateIsPortrait);
    window.addEventListener("orientationchange", this.updateIsPortrait);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateIsPortrait);
    window.removeEventListener("orientationchange", this.updateIsPortrait);
  },
  computed: {
    cards() {
      if (!this.cardList.length) {
        return defaultCards;
      }
      return defaultCards.map((defaultCard, index) => ({
        ...defaultCard,
        ...(this.cardList[index] || {}),
      }));
    },
    groupStyle() {
      if (this.isPortrait) {
        return {
          top: this.mobTop,
          left: this.mobLeft,
          zIndex: this.zIndex,
        };
      }
      return {
        top: this.top,
        left: this.left,
        zIndex: this.zIndex,
      };
    },
  },
  methods: {
    updateIsPortrait() {
      this.isPortrait = isPortraitFun();
    },
    getNormalSrc(card) {
      return this.isPortrait ? card.mobSrc : card.normalSrc;
    },
    scrollToSection(sectionId) {
      const card = this.cards.find((item) => item.sectionId === sectionId);
      const targetId = this.isPortrait && card && card.mobSectionId ? card.mobSectionId : sectionId;
      const element = document.getElementById(targetId);
      if (!element) return;
      const yOffset = this.isPortrait ? -60 : -78;
      window.scrollTo({
        top: element.getBoundingClientRect().top + window.scrollY + yOffset,
        behavior: "smooth",
      });
    },
    openLink(link) {
      if (!link) return;
      window.open(link, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.card-group {
  position: relative;
}

.card-group-pc {
  position: absolute;
  width: calc(1460 / 1920 * 100vw);
  height: calc(750 / 1920 * 100vw);
  transform: translateX(-50%);
  display: grid;
  grid-template-columns: calc(583 / 1920 * 100vw) calc(857 / 1920 * 100vw);
  grid-template-rows: calc(365 / 1920 * 100vw) calc(365 / 1920 * 100vw);
  gap: calc(20 / 1920 * 100vw);
}

.card-group-mob {
  position: absolute;
  width: calc(670 / 750 * 100vw);
  display: flex;
  flex-direction: column;
  gap: calc(16 / 750 * 100vw);
  transform: translateX(-50%);
}

.card-item {
  position: relative;
  overflow: hidden;
}

.card-group-pc .card-item-large {
  grid-row: 1 / 3;
}

.card-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.card-image-hover {
  opacity: 0;
  transition: opacity 0.25s linear;
}

.card-item:hover {
.card-group-pc & {
  .card-image-hover {
    opacity: 1;
  }

  .card-hotspot {
    pointer-events: auto;
    display: block;
  }
  }
}

.card-hotspot {
  position: absolute;
  display: none;
  width: calc(131 / 1920 * 100vw);
  height: calc(48 / 1920 * 100vw);
  padding: 0;
  border: 0;
  background: rgba(255, 255, 255, 0);
  cursor: pointer;
  pointer-events: none;
}

.card-group-pc .card-item-large {
  .card-hotspot {
    top: calc(223 / 1920 * 100vw);
  }

  .card-hotspot-intro {
    left: calc(58 / 1920 * 100vw);
  }

  .card-hotspot-link {
    left: calc((58 + 131 + 10) / 1920 * 100vw);
  }
}

.card-group-pc .card-item-small {
  .card-hotspot {
    top: calc(256 / 1920 * 100vw);
  }

  .card-hotspot-intro {
    left: calc(61 / 1920 * 100vw);
  }

  .card-hotspot-link {
    left: calc((61 + 131 + 10) / 1920 * 100vw);
  }
}

.card-group-mob {
  .card-item {
    width: calc(670 / 750 * 100vw);
    height: calc(286 / 750 * 100vw);
  }

  .card-hotspot {
    display: block;
    top: calc(196 / 750 * 100vw);
    width: calc(131 / 750 * 100vw);
    height: calc(48 / 750 * 100vw);
    pointer-events: auto;
  }

  .card-hotspot-intro {
    left: calc(36 / 750 * 100vw);
  }

  .card-hotspot-link {
    left: calc((36 + 131 + 10) / 750 * 100vw);
  }
}
</style>
